<template>
  <!-- ADD Bank -->
  <v-layout row justify-center>
    <v-dialog v-model="addBankModal" persistent max-width="440px">
      <v-card>
        <form action="" @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex xs11 sm11 md11><span class="headline">Add Bank</span></v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn flat @click="closeAddBankModal(), $validator.reset()" class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
              >
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert type="success" :value="checkAlert">
              Bank added successfully
            </v-alert>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm10 md4>
                  <v-text-field
                    label="Bank Name*"
                    v-model="addBankData.bank_name"
                    :error-messages="errors.collect('Bank Name')"
                    v-validate="'required'"
                    data-vv-name="Bank Name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeAddBankModal(), $validator.reset()"
              outline
              color="normal"
              >Cancel</v-btn
            >
            <v-btn type="submit" style="height:auto; margin-right: 3%" outline color="success"
              >Add</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD Bank -->
</template>

<script>
export default {
  props: ['addBank', 'addBankData', 'addBankModal', 'checkAlert', 'closeAddBankModal'],

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addBank()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/addBank.vue